"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _notice = require("@/api/basic/notice");
var _couponExpand = require("@/api/activity/couponExpand");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 你要根据接口路径改
var _default = exports.default = {
  name: 'ExpandAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: String,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        this.getShopList();
        console.log('newId', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.fetchActDetail(newId);
        }
        ;
        console.log('actId', newId);
      }
    },
    // 当切换“全部门店”时，自动全选或清空所有门店
    isNationWide: function isNationWide(val) {
      console.log('isNationWide changed to', val);
      // 先清理/设置 selectedShops 和 checkedCities，再重新计算
      if (val == 0) {
        // 不按门店：只生成一次
        this.checkedCities = [];
        this.selectedShops = [];
        this.allCodeNum = Number(this.form.couponCount) || 0;
      } else if (val == 2) {
        // 全部门店：全选所有门店，selectedShops 存放所有门店对象
        this.checkedCities = this.allShopIds.slice();
        this.selectedShops = this.shoplist.reduce(function (acc, city) {
          return acc.concat(city.dealerList || []);
        }, []);
        var cnt = Number(this.form.couponCount) || 0;
        this.allCodeNum = cnt * (this.allShopIds.length || 0);
      } else {
        // 选择门店
        // 保持已有选择，清空复选框状态（用户可手动选择）
        // 若希望切换到“选择门店”时保留之前选中，可注释下一行
        this.checkedCities = [];
        this.selectedShops = [];
        this.allCodeNum = Number(this.form.couponCount) || 0;

        // selectedShops 保持当前已选对象（若需要清空可设置 []）
        this.recalcAllCodeNum();
      }
    },
    // 监控生成数量变化，实时更新 allCodeNum
    'form.couponCount': function formCouponCount(val) {
      this.recalcAllCodeNum();
    },
    // 监控已选门店对象数组（数量变动）时重新计算
    selectedShops: {
      handler: function handler() {
        this.recalcAllCodeNum();
      },
      deep: true
    }
  },
  computed: {
    // 所有门店 id 列表（用于全选）
    allShopIds: function allShopIds() {
      return this.shoplist.reduce(function (acc, city) {
        var ids = (city.dealerList || []).map(function (s) {
          return s.dealerId;
        });
        return acc.concat(ids);
      }, []);
    } // ...existing computed...
  },
  data: function data() {
    return {
      allCodeNum: 0,
      checkedCities: [],
      shoplist: [],
      isNationWide: 0,
      // 新增：真正保存已选门店的对象数组（包含 id、name、num 等）
      selectedShops: [],
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏

      fileList: [],
      time: [],
      typeName1: '',
      typeName2: '',
      typeName3: '',
      form: {
        activityName: '',
        activityTitle: '',
        couponCount: '',
        activityPackageList: [{
          couponId: '',
          quantity: ''
        }],
        ruleType: 'YEAR',
        maxExchangeCount: '',
        activityDesc: '',
        status: 1,
        coverImage: '',
        storeList: []
      },
      rules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        activityTitle: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        activityTips: [{
          required: true,
          message: '请输入提示语',
          trigger: 'blur'
        }],
        couponCount: [{
          required: true,
          message: '请输入生成数量',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入正整数',
          trigger: 'blur'
        }],
        maxExchangeCount: [{
          required: true,
          message: '请输入限制门槛',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入正整数',
          trigger: 'blur'
        }],
        activityDesc: [{
          required: true,
          message: '请输入购买及使用规则',
          trigger: 'blur'
        }]
      },
      couponOptions1: [],
      couponLoading: false
    };
  },
  mounted: function mounted() {
    this.getResPathInfo();
  },
  methods: {
    // 新增：统一重算实际生成券码数量
    recalcAllCodeNum: function recalcAllCodeNum() {
      var cntPer = Number(this.form.couponCount) || 0;
      if (this.isNationWide == 0) {
        this.allCodeNum = cntPer;
      } else if (this.isNationWide == 2) {
        this.allCodeNum = cntPer * (this.allShopIds.length || 0);
      } else {
        // 按门店：所有已选门店数量之和（用店铺 num，若无则取表单生成数量）
        this.allCodeNum = (this.selectedShops || []).reduce(function (sum, s) {
          return sum + (Number(s.num) || cntPer);
        }, 0);
      }
    },
    getResPathInfo: function getResPathInfo() {
      var _this = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this.resPath = res.data;
      });
    },
    // 是否城市下所有门店已被选中
    isCityAllSelected: function isCityAllSelected(city) {
      var _this2 = this;
      console.log('city', city);
      if (!city || !city.dealerList || city.dealerList.length == 0) return false;
      return city.dealerList.every(function (s) {
        return _this2.checkedCities.includes(s.dealerId);
      });
    },
    // 城市是否部分选中（用于 indeterminate）
    isCityIndeterminate: function isCityIndeterminate(city) {
      var _this3 = this;
      if (!city || !city.dealerList || city.dealerList.length === 0) return false;
      var selectedCount = city.dealerList.filter(function (s) {
        return _this3.checkedCities.includes(s.dealerId);
      }).length;
      return selectedCount > 0 && selectedCount < city.dealerList.length;
    },
    // 切换城市：checked 为布尔值，true 时加入该城市所有门店 id，false 时移除
    toggleCity: function toggleCity(city, checked) {
      var _this4 = this;
      var ids = (city.dealerList || []).map(function (s) {
        return s.dealerId;
      });
      if (checked) {
        city.dealerList.forEach(function (s) {
          // 保证数量有默认值
          if (!s.num || s.num === '') {
            s.num = _this4.form.couponCount;
          }
          // checkedCities 用于 UI 复选框组（去重）
          if (!_this4.checkedCities.includes(s.dealerId)) {
            _this4.checkedCities.push(s.dealerId);
          }
          // 推入原始对象引用（不要克隆），保持 num 的实时同步
          if (!_this4.selectedShops.find(function (x) {
            return x.dealerId === s.dealerId;
          })) {
            _this4.selectedShops.push(s);
          }
        });
        // 去重（保险）
        this.checkedCities = Array.from(new Set(this.checkedCities.concat(ids)));
      } else {
        city.dealerList.forEach(function (s) {
          s.num = '';
          var idx = _this4.selectedShops.findIndex(function (x) {
            return x.dealerId === s.dealerId;
          });
          if (idx > -1) _this4.selectedShops.splice(idx, 1);
        });
        this.checkedCities = this.checkedCities.filter(function (dealerId) {
          return !ids.includes(dealerId);
        });
      }
      // 单店选择/取消或数量变化后重算总数
      this.recalcAllCodeNum();
    },
    changeShop: function changeShop(shop, checked) {
      if (!checked) {
        shop.num = '';
        var idx = this.selectedShops.findIndex(function (x) {
          return x.dealerId === shop.dealerId;
        });
        if (idx > -1) this.selectedShops.splice(idx, 1);
      } else {
        if (!shop.num || shop.num === '') {
          shop.num = this.form.couponCount;
        }
        var exist = this.selectedShops.find(function (x) {
          return x.dealerId === shop.dealerId;
        });
        if (exist) {
          // 已保存的是同一引用（或同 id），更新数量
          exist.num = shop.num;
        } else {
          // 推入原始对象引用，保证 num 实时同步
          this.selectedShops.push(shop);
        }
      }
      // 单店选择/取消或数量变化后重算总数
      this.recalcAllCodeNum();
    },
    handleAdd: function handleAdd() {
      console.log('handleAdd');
      this.form.activityPackageList.push({
        couponId: '',
        quantity: ''
      });
    },
    changeAllShop: function changeAllShop(e) {
      console.log('changeAllShop', e);
    },
    handleReduce: function handleReduce(index) {
      if (this.form.activityPackageList.length > 1) {
        this.form.activityPackageList.splice(index, 1);
      } else {
        this.$message.warning('至少保留一项优惠券组合');
      }
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    fetchActDetail: function fetchActDetail(id) {
      var _this5 = this;
      console.log('fetchActDetail id', this.storeList);
      var id2 = id;
      if (id.endsWith('_copy')) {
        id2 = id.replace('_copy', '');
      }
      _couponCode.default.getDetail(id2).then(function (res) {
        if (!res) return;
        if (id.endsWith('_copy')) {
          res.id = null; // 新增复制时，ID 置空
        }
        _this5.form = res; // 假设返回的数据结构是 { data: {...} }

        var promises = _this5.form.activityPackageList.map(function (item) {
          return (0, _couponExpand.getCouponByThirdId)(item.couponId).then(function (response) {
            response.data.thirdCouponId = Number(response.data.thirdCouponId);
            // 不要赋值 push 的返回值，直接 push 到数组或返回数据由 Promise.all 统一赋值
            _this5.$set(item, 'couponName', response.data.typeName || '');
            return response.data;
          }).catch(function (error) {
            console.error('获取失败:', error);
            return null;
          });
        });
        Promise.all(promises).then(function (results) {
          // 过滤掉失败的 null，然后整体替换 couponOptions1
          _this5.couponOptions1 = results.filter(function (r) {
            return r;
          });
          console.log('couponOptions12', _this5.couponOptions1);
        });
        _this5.isNationWide = res.isStoreMode;
        _this5.selectedShops = [];

        // 把 storeList 信息反显到 shoplist（页面中的门店结构）
        _this5.shoplist.forEach(function (city) {
          (city.dealerList || []).forEach(function (shop) {
            var match = res.storeList.find(function (s) {
              return String(s.storeId) === String(shop.dealerId);
            });
            if (match) {
              // 反显生成数量
              shop.num = match.couponCount || _this5.form.couponCount || shop.num;
              // 标记为已选择
              if (!_this5.selectedShops.find(function (x) {
                return x.dealerId === shop.dealerId;
              })) {
                // 使用原始对象引用，保持双向绑定
                _this5.selectedShops.push(shop);
              }
            } else {
              // 未选中则清空数量显示（视需求可保留原值）
              shop.num = shop.num || '';
            }
          });
        });
        setTimeout(function () {
          _this5.checkedCities = res.storeList.map(function (s) {
            return s.storeId;
          });
          _this5.allCodeNum = res.storeList.reduce(function (acc, cur) {
            return acc + cur.couponCount;
          }, 0);
        }, 1000);
        console.log(' this.shoplist', _this5.shoplist, _this5.selectedShops, _this5.checkedCities);
        _this5.time = [res.startTime, res.endTime];
        _this5.form.startTime = null;
        _this5.form.endTime = null;
        _this5.fileList = [{
          name: '封面',
          url: res.coverImage
        }];
        console.log(" res", res);
      });
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this6 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this6.couponOptions1 = res.records || [];
      }).finally(function () {
        _this6.couponLoading = false;
      });
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this7 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', "/couponCode/");
      (0, _notice.uploadPhoto)(formData).then(function (res) {
        var url = _this7.resPath + res.data; // 按实际调整
        console.log('上传结果', url);
        // 更新展示地址
        _this7.form.coverImage = url;

        // 替换上传组件的 fileList（最多一张）
        _this7.fileList = [{
          name: '封面图',
          url: url
        }];
        _this7.$message.success('上传成功');
      });
    },
    handleUploadRemove: function handleUploadRemove(index) {
      this.fileList = [];
      this.form.coverImage = '';
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;
      console.log('isNationWide', this.isNationWide);
      // this.loading = true; // 开始加载
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var i, item, idx, qty, formData;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  _context.next = 1;
                  break;
                }
                _this8.loading = false; // 停止加载
                return _context.abrupt("return");
              case 1:
                i = 0;
              case 2:
                if (!(i < _this8.form.activityPackageList.length)) {
                  _context.next = 5;
                  break;
                }
                item = _this8.form.activityPackageList[i];
                idx = i + 1;
                if (!(!item.couponId && !item.couponName)) {
                  _context.next = 3;
                  break;
                }
                // 如果是已保存状态 couponName 也可能存在
                _this8.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u9009\u62E9\u4F18\u60E0\u5238"));
                return _context.abrupt("return");
              case 3:
                qty = String(item.quantity || '').trim();
                if (/^[1-9]\d*$/.test(qty)) {
                  _context.next = 4;
                  break;
                }
                _this8.$message.error("\u8BF7\u4E3A\u7B2C ".concat(idx, " \u9879\u586B\u5199\u6B63\u786E\u7684\u6570\u91CF\uFF08\u6B63\u6574\u6570\uFF09"));
                return _context.abrupt("return");
              case 4:
                i++;
                _context.next = 2;
                break;
              case 5:
                if (_this8.time[0]) {
                  _context.next = 6;
                  break;
                }
                _this8.$message.error('请选择活动时间');
                return _context.abrupt("return");
              case 6:
                formData = _this8.form;
                formData.activityPackageList = formData.activityPackageList.map(function (item, index) {
                  return {
                    quantity: item.quantity,
                    couponId: item.couponId,
                    sort: index + 1
                  };
                });
                formData.activityPackageList.forEach(function (item, index) {
                  item.sort = index + 1;
                });
                formData.isStoreMode = _this8.isNationWide;
                formData.storeList = [];
                if (_this8.isNationWide == 1) {
                  formData.storeList = _this8.selectedShops.map(function (s) {
                    return {
                      storeId: s.dealerId,
                      couponCount: s.num || _this8.form.couponCount
                    };
                  });
                }
                formData.startTime = _this8.time[0];
                formData.endTime = _this8.time[1];
                console.log('formData', formData);
                _this8.loading = true; // 开始加载

                _couponCode.default.addAct(formData).then(function (res) {
                  if (res.code === 200) {
                    _this8.loading = false; // 停止加载
                    _this8.$message.success('操作成功');
                    _this8.handleClose();
                  } else {
                    _this8.loading = false; // 停止加载
                    _this8.$message.error(res.message);
                  }
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.$emit('saved'); // 通知父组件刷新列表
    },
    getShopList: function getShopList() {
      var _this9 = this;
      _couponCode.default.getStoreList().then(function (res) {
        res.forEach(function (city) {
          city.dealerList = (city.dealerList || []).map(function (dealer) {
            return Object.assign({}, dealer, {
              num: '' // 初始化数量为空，保证 v-model="shop.num" 可用且响应式
            });
          });
        });
        _this9.shoplist = res;
      });
    }
  }
};